// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__LUBcM","menu__btn":"Menu_menu__btn__lRImv"};